import type { Venue } from '@/api/types';

/**
 * A venue's name as a filter option shows it. EncorePro can send a venue with
 * no name (`Venue.name` is `string | null`); the Productions, Events and
 * Pipeline venue filters used to render such a venue as a blank option, then as
 * its raw UUID, neither of which anyone could pick out. An unnamed venue now
 * reads "Unnamed venue · <where>": its neighbourhood, else its city, else the
 * first eight characters of its id, so two unnamed venues in one menu stay
 * distinguishable.
 */
export function venueOptionLabel(
  venue: Pick<Venue, 'id' | 'name' | 'neighborhood' | 'city'>,
): string {
  if (venue.name) return venue.name;
  const where = venue.neighborhood || venue.city || venue.id.slice(0, 8);
  return `Unnamed venue · ${where}`;
}
